import type {SelectPriceProps} from "~/ProductDetails/components/ProductSummary/PdpSummaryHelper";
import {getListPrice} from "~/feature/ProductDescriptor/v1/productDescriptorUtils";
import {Price as PriceV1, PriceType} from "~/common/components/Price/v1/Price";
import {FontSize, getFontStyle} from "~/common/components/materialInput/Fonts";
import {C_ON_SURFACE_LOW_EMPHASIS} from "~/common/components/icon/Colors";
import {makeStyles} from "@mui/styles";

const useListPriceStyles = makeStyles({
  root: {
    marginTop: "20px",
  },
  price: {
    ...getFontStyle(FontSize.TitleMedium),
    fontWeight: "bold",
  },
  label: {
    ...getFontStyle(FontSize.LabelLarge),
    color: C_ON_SURFACE_LOW_EMPHASIS,
    marginTop: "5px",
  },
});

export const ListPrice = (props: Omit<SelectPriceProps, "quantity">) => {
  const classes = useListPriceStyles();

  const price = getListPrice(props);

  if (!price || !price.value) {
    return null;
  }

  return <PriceV1 variant={PriceType.ProductListPrice} price={price} classes={classes} unit={price.unit} />;
};
